export const BASE_API_URL = 'https://teenpatti.money91.com'
export const SOCKET_URL = 'wss://teenpatti.money91.com'
// export const BASE_API_URL = 'https://test4.services-money91.com'
// export const SOCKET_URL = 'wss://test4.services-money91.com'
// export const LOCAL_URL = 'https://test4.services-money91.com'
// export const SOCKET_LOCAL_URL = 'wss://test4.services-money91.com'
// export const LOCAL_URL = 'http://13.233.236.54:5005'
// export const SOCKET_LOCAL_URL = 'ws://13.233.236.54:5005'
export const API_REDIS = 'https://dev1.money91.com'
